<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form class="infoBoxForm" @submit.prevent="handleSubmit(saveProfile)">
        <section>
          <div class="row5">
            <article class="inner infoInner">
              <div class="infoTitle mobileCenter">
                <h1>프로필 정보</h1>
              </div>

              <TabInformation
                :tabs="tabs"
                :activeTab="activeTab"
                :handleChangeTab="handleChangeTab"
                :networkingOn.sync="signupInfo.isOn"
                class="mb-5"
              />

              <div v-if="activeTab === 0">
                <div class="flex mobileFlex wd100">
                  <div class="wd50">
                    <div class="profileImgBox wd100">
                      <div class="profileImgInputBox preview-image">
                        <img :src="imageUrl" alt="" class="upload-name" />
                        <label for="input-file"></label>
                        <input
                          type="file"
                          id="input-file"
                          class="upload-hidden"
                          @change="setFileImage"
                        />
                      </div>
                    </div>
                  </div>

                  <!-- Right side  -->
                  <div class="flex flex-col wd50">
                    <div class="inputBox infoBox wd50">
                      <label>아이디</label>
                      <input v-model="signupInfo.id" maxlength="20" disabled />
                    </div>

                    <ValidationProvider
                      class="inputBox infoBox wd50"
                      name="비밀번호"
                      rules="pw"
                      vid="비밀번호"
                      v-slot="{ errors }"
                    >
                      <label
                        >비밀번호 <span class="labelItem">*</span> (특수문자
                        포함, 8자리 이상)</label
                      >
                      <input
                        type="password"
                        v-model="signupInfo.password"
                        maxlength="16"
                        autocomplete="new-password"
                      />
                      <span class="notValidationTxt">{{ errors[0] }}</span>
                    </ValidationProvider>

                    <ValidationProvider
                      class="inputBox infoBox wd50"
                      name="비밀번호 재확인"
                      rules="confirmed:@비밀번호"
                      vid="비밀번호 재설정"
                      v-slot="{ errors }"
                    >
                      <label
                        >비밀번호 확인 <span class="labelItem">*</span> (한번 더
                        입력해주세요.)</label
                      >
                      <input
                        type="password"
                        v-model="confirmedPassword"
                        maxlength="16"
                      />
                      <span class="notValidationTxt">{{ errors[0] }}</span>
                    </ValidationProvider>
                    <ValidationProvider
                      class="inputBox infoBox wd50"
                      name="담당자"
                      rules="required|name"
                      v-slot="{ errors }"
                    >
                      <label>담당자<span class="labelItem">*</span></label>
                      <input v-model="signupInfo.name" maxlength="16" />
                      <span class="notValidationTxt">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>

                <div class="flex mobileFlex">
                  <ValidationProvider
                    class="inputBox infoBox wd50"
                    name="이메일"
                    rules="required|email"
                    v-slot="{ errors }"
                  >
                    <label>이메일<span class="labelItem">*</span></label>
                    <input v-model="signupInfo.email" maxlength="40" />
                    <span class="notValidationTxt">{{ errors[0] }}</span>
                  </ValidationProvider>

                  <ValidationProvider
                    class="inputBox infoBox wd50"
                    name="담당자 휴대폰 번호"
                    rules="required|mobileTel"
                    v-slot="{ errors, valid }"
                  >
                    <label
                      >담당자 휴대폰 번호<span class="labelItem">*</span></label
                    >
                    <input
                      v-model="signupInfo.phone"
                      @keypress="eventUtil.onKeyPressForOnlyDigit($event)"
                      @change="changePhoneNumber(valid)"
                      maxlength="11"
                    />
                    <input
                      type="button"
                      value="인증번호 받기"
                      @click="onClickRequestVerifyNumber(valid)"
                      :disabled="!vertifyPhoneNumber"
                    />
                    <span class="notValidationTxt">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>

                <div class="flex mobileFlex">
                  <ValidationProvider
                    class="inputBox infoBox wd50"
                    name="기업명"
                    rules="required|corpName"
                    v-slot="{ errors }"
                  >
                    <label>기업명<span class="labelItem">*</span></label>
                    <input v-model="signupInfo.companyName" maxlength="42" />
                    <span class="notValidationTxt">{{ errors[0] }}</span>
                  </ValidationProvider>
                  <ValidationProvider
                    class="inputBox infoBox wd50"
                    name="인증번호"
                    rules="verifyNum"
                    v-slot="{ errors, valid }"
                  >
                    <label>인증 번호 6자리 입력</label>
                    <input
                      v-model="verifyNumber"
                      maxlength="6"
                      @keypress="eventUtil.onKeyPressForOnlyDigit($event)"
                      :placeholder="counterPlaceHolder"
                    />
                    <input
                      type="button"
                      value="03:00"
                      @click="onClickConfirmVerifyNumber(valid)"
                      :disabled="counter == 0"
                    />
                    <span class="notValidationTxt">{{ errors[0] }}</span>
                    <vac
                      ref="verifyNumberCounter"
                      :autoStart="false"
                      :end-time="new Date().getTime() + 180000"
                    >
                      <template v-slot:process="{ timeObj }">
                        {{ onProcesssVerifyNumberCounter(timeObj) }}
                      </template>
                      <template v-slot:finish>
                        {{ onFinishVerifyNumberCounter() }}
                      </template>
                    </vac>
                  </ValidationProvider>
                </div>

                <div class="flex mobileFlex">
                  <ValidationProvider
                    class="inputBox infoBox wd50"
                    name="대표 번호"
                    v-slot="{ errors }"
                  >
                    <label>대표 번호</label>
                    <input
                      v-model="signupInfo.representativeNumber"
                      @keypress="eventUtil.onKeyPressForOnlyDigit($event)"
                      maxlength="11"
                    />
                    <span class="notValidationTxt">{{ errors[0] }}</span>
                  </ValidationProvider>
                  <ValidationProvider
                    class="inputBox infoBox wd50"
                    name="설립연도"
                    rules="required|year"
                    v-slot="{ errors }"
                  >
                    <label>설립연도<span class="labelItem">*</span></label>
                    <input
                      v-model="signupInfo.establishmentYear"
                      maxlength="10"
                      placeholder="YYYY"
                    />
                    <span class="notValidationTxt">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>

                <div class="flex mobileFlex">
                  <ValidationProvider
                    class="inputBox infoBox wd50"
                    name="매출 규모"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label>매출 규모<span class="labelItem">*</span></label>
                    <input v-model="signupInfo.profitSize" maxlength="21" />
                    <span class="notValidationTxt">{{ errors[0] }}</span>
                  </ValidationProvider>
                  <ValidationProvider
                    class="inputBox infoBox wd50"
                    name="사원수"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label>사원 수<span class="labelItem">*</span></label>
                    <input
                      v-model="signupInfo.memberSize"
                      @keypress="eventUtil.onKeyPressForOnlyDigit($event)"
                      maxlength="21"
                    />
                    <span class="notValidationTxt">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>

                <div class="flex mobileFlex">
                  <div class="inputBox infoBox wd100">
                    <label>홈페이지</label>
                    <input v-model="signupInfo.homePage" maxlength="85" />
                  </div>
                </div>

                <div class="flex mobileFlex">
                  <ValidationProvider
                    class="inputBox infoBox wd50"
                    name="업종"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label>업종<span class="labelItem">*</span></label>
                    <div class="bspSelectBox">
                      <b-form-select
                        v-model="signupInfo.fieldType"
                        :options="fieldTypeOptions"
                      ></b-form-select>
                    </div>
                    <span class="notValidationTxt">{{ errors[0] }}</span>
                  </ValidationProvider>
                  <ValidationProvider
                    class="inputBox infoBox wd50"
                    name="기업 형태"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label>기업형태<span class="labelItem">*</span></label>
                    <div class="bspSelectBox">
                      <b-form-select
                        v-model="signupInfo.companyType"
                        :options="companyTypeOptions"
                      ></b-form-select>
                    </div>
                    <span class="notValidationTxt">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>

                <div class="flex mobileFlex">
                  <ValidationProvider
                    class="inputBox infoBox wd100 addressPosition"
                    name="주소"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label>주소<span class="labelItem">*</span></label>
                    <input
                      v-model="addr1"
                      readonly
                      @click="onClickSearchAdderss"
                      maxlength="40"
                    />
                    <input
                      type="button"
                      value="우편번호 찾기"
                      @click="onClickSearchAdderss"
                    />
                    <span class="notValidationTxt">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>

                <div class="flex mobileFlex">
                  <ValidationProvider
                    class="inputBox infoBox wd100 addressPosition"
                    name="상세주소"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label>상세주소<span class="labelItem">*</span></label>
                    <input v-model="signupInfo.addressDetail" maxlength="85" />
                    <span class="notValidationTxt">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>

                <div class="warningInfo">
                  <p>
                    위의 항목 중 수정을 원하는 항목을 클릭하시고 새로 수정할
                    정보를 입력하세요.
                    <br />
                    정보입력 후 아래의 수정버튼을 누르시면 회원정보 수정이
                    진행됩니다.
                  </p>
                </div>
              </div>
              <CorpNetworkingInformation
                v-if="activeTab === 1"
                :form="signupInfo"
                @update="onCorpNetworkingInformationChange"
              />
            </article>
            <!-- 이동 방식 수정 해야 함. 2021.06.24 -->
            <div class="btnBox flex">
              <button type="submit" class="btnFont redborderBtn">
                수 정
              </button>
              <button
                type="type"
                class="btnFont orangeBtn fixWdBtn"
                @click="membershipWithDrawal"
              >
                회원탈퇴
              </button>
            </div>
          </div>
        </section>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapActions, mapGetters, mapState } from "vuex";
import * as eventUtil from "@/utils/eventUtil";
import axios from "@/axios/axios";
import * as addressFind from "@/utils/addressFind";
import * as jwtUtil from "@/utils/jwtUtil";
import * as corpUtil from "@/utils/corpUtil";
import * as htmlUtil from "@/utils/htmlUtil";
import TabInformation from "@/components/tabs/TabInformation.vue";
import CorpNetworkingInformation from "./CorpNetworkingInformation.vue";
import { resolveApiUrl } from "@/data/url";

export default {
  name: "CorpProfile",
  components: {
    ValidationObserver,
    ValidationProvider,
    TabInformation,
    CorpNetworkingInformation,
  },
  computed: {
    ...mapGetters("auth", ["getUser", "isChecked"]),
    ...mapState("auth", ["user"]),
  },
  data() {
    return {
      eventUtil: eventUtil,
      tabs: ["기본 정보", "네트워킹 정보"],
      activeTab: 0,
      signupInfo: {
        roleName: this.$role.CORP,
        password: "",
      },
      checkedId: "", // 중복검사 완료된 아이디
      checkedPhoneNumber: "", // 인증을 요청한 전화번호
      confirmedPassword: "", // 비밀번호 재확인 값
      isVerified: false, // 전화번호 인증 여부
      verifyNumber: "", // 인증번호
      counter: 0, // 인증번호 유효 시간 카운터
      counterPlaceHolder: "", // 인증번호 유효 시간 카운터(출력용)
      addr1: "", // addressFind util 주소검색 결과
      postcode: "", // addressFind util 주소검색 결과(우편번호)
      fieldTypeOptions: corpUtil.fieldType,
      companyTypeOptions: corpUtil.companyType,
      imageUrl: require("@/assets/images/user/camera-icon.png"),
      file: null,
      idx: null,
      originalPhoneNumber: "",
      vertifyPhoneNumber: false,
    };
  },
  created() {
    this.getUserInfo();
  },
  mounted() {
    // if (this.isChecked == false) {
    //   this.$alert("알림", "필수 정보가 없습니다. 프로필을 완성해주세요.");
    // }
  },
  methods: {
    ...mapActions("file", ["uploadAvatar"]),
    ...mapActions("corp", ["requestCorpDetail", "updateCorp"]),
    ...mapActions("sms", ["requestVerifyNumber", "confirmVerifyNumber"]),
    ...mapActions("auth", ["signout"]),
    onClickRequestVerifyNumber(isValidPhoneNumber) {
      if (!isValidPhoneNumber || this.signupInfo.phone === "") {
        alert("휴대폰번호를 확인해주세요.");
        return;
      }

      const phoneNumber = this.signupInfo.phone;
      this.isVerified = false;

      this.requestVerifyNumber({
        phoneNumber: phoneNumber,
        contents: "[경희대SSK]휴대폰 번호 변경\r\n전화번호 인증",
      })
        .then((response) => {
          const data = response.data;

          if (data.RESULT == "true") {
            this.checkedPhoneNumber = phoneNumber; // 인증번호를 요청한 전화번호 저장
            this.$refs.verifyNumberCounter.startCountdown("restart");
            this.$alert(
              "알림",
              "인증번호를 발송했습니다.(유효시간 3분) <br>" +
                "인증번호가 오지 않으면 입력하신 정보가 정확한지 확인하여 주세요.<br>" +
                "이미 가입된 번호이거나, 가상전화번호는 인증번호를 받을 수 없습니다.",
            );
          } else {
            this.checkedPhoneNumber = ""; // 인증번호를 요청한 전화번호 초기화
            this.$refs.verifyNumberCounter.finishCountdown();
            if (
              data.ERROR_CODE == "SUCCESSIVE_REQUEST" ||
              data.ERROR_CODE == "BLOCKED"
            ) {
              this.$alert("알림", "5분 뒤에 다시 시도해주세요.");
            } else {
              this.$alert("알림", "인증번호 요청을 실패했습니다.");
            }
          }
        })
        .catch(() => {
          this.checkedPhoneNumber = ""; // 인증번호를 요청한 전화번호 초기화
          this.$refs.verifyNumberCounter.finishCountdown();
          this.$alert("알림", "인증번호 요청을 실패했습니다.");
        });
    },
    onClickConfirmVerifyNumber(isValidVerifyNumber) {
      if (!isValidVerifyNumber || this.verifyNumber === "") {
        return;
      }

      this.confirmVerifyNumber({
        phoneNumber: this.checkedPhoneNumber,
        verifyNum: this.verifyNumber,
      })
        .then((response) => {
          const data = response.data;

          if (data.RESULT == "true") {
            this.isVerified = true;
            this.$refs.verifyNumberCounter.finishCountdown();
            this.$alert("알림", "인증되었습니다.");
          } else {
            this.isVerified = false;
            this.$alert("알림", "유효하지 않은 인증번호 입니다.");
          }
        })
        .catch(() => {
          this.isVerified = false;
          this.$alert("알림", "요청 실패");
        });
    },
    onProcesssVerifyNumberCounter(timeObj) {
      this.counter = timeObj.m * 60 + timeObj.s;
      this.counterPlaceHolder = `${timeObj.m}:${timeObj.s}`;
    },
    onFinishVerifyNumberCounter() {
      this.counter = 0;
      this.counterPlaceHolder = "";
    },
    onClickSearchAdderss() {
      addressFind.FindAddress(this);
    },
    setFileImage(event) {
      let file = event.target.files[0];
      let fileName = event.target.files[0].name;

      let fileNameArr = fileName.split(".");
      let ext = fileNameArr[fileNameArr.length - 1];

      let checkExts = [
        "gif",
        "png",
        "jpg",
        "jpeg",
        "GIF",
        "PNG",
        "JPG",
        "JPEG",
      ];

      var check = checkExts.some(function(checkExt) {
        return ext === checkExt;
      });

      if (!check) {
        this.$alert(
          "알림",
          "업로드가 불가한 확장자입니다. (gif, png, jpg, jpeg 파일만 업로드할 수 있습니다.)",
        );
        return;
      }

      if (file.size >= 1024 * 1024 * 10) {
        this.$alert("알림", "첨부파일은 10mb이하의 크기만 업로드 가능합니다.");
        return;
      }

      this.file = file;
      this.imageUrl = URL.createObjectURL(this.file);
    },
    handleChangeTab(index) {
      this.activeTab = index;
    },
    onCorpNetworkingInformationChange(val) {
      this.signupInfo = this.lodash.assign(this.signupInfo, val);
    },
    getUserInfo() {
      this.requestCorpDetail()
        .then((response) => {
          if (response.status == 200) {
            let user = response.data;
            this.signupInfo = this.lodash.cloneDeep(user);
            this.originalPhoneNumber = user.phone;
            this.addr1 = htmlUtil.stringToTag(user.address);

            this.signupInfo.address = this.addr1;
            this.signupInfo.addressDetail = htmlUtil.stringToTag(
              user.addressDetail,
            );

            this.idx = user.idx;

            if (user.avatar) {
              this.imageUrl = resolveApiUrl("/api" + user.avatar);
            }
          }
        })
        .catch((error) => {
          console.error(error);
          this.$alert(
            "상세정보를 불러오는 중 에러가 발생했습니다. 관리자에게 문의해주세요.",
          );
        });
    },
    async saveProfile() {
      const user = this.user;
      const corpInfo = {
        id: user.id,
        phone: this.signupInfo.phone,
        email: this.signupInfo.email,
        name: this.signupInfo.name,
        password: this.signupInfo.password || "",
        avatar: this.signupInfo.avatar,
        homePage: this.signupInfo.homePage,
        address: this.signupInfo.address,
        addressDetail: this.signupInfo.addressDetail,
        companyType: this.signupInfo.companyType,
        companyName: this.signupInfo.companyName,
        profitSize: this.signupInfo.profitSize,
        memberSize: this.signupInfo.memberSize,
        representativeNumber: this.signupInfo.representativeNumber,
        establishmentYear: this.signupInfo.establishmentYear,
        fieldType: this.signupInfo.fieldType,
        idealTalent: this.signupInfo.idealTalent,
        productServiceDesc: this.signupInfo.productServiceDesc,
        productServiceName: this.signupInfo.productServiceName,
        aboutMe: this.signupInfo.aboutMe,
        industries1: this.signupInfo.industries1,
        industries2: this.signupInfo.industries2,
        activities: this.signupInfo.activities,
        isOn: this.signupInfo.isOn,
      };

      if (
        user.phone != corpInfo.phone &&
        (corpInfo.phone != this.checkedPhoneNumber || !this.isVerified)
      ) {
        this.$alert("알림", "전화번호를 인증해주세요.");
        return;
      }

      if (!(corpInfo.password === this.confirmedPassword)) {
        this.$alert("알림", "비밀번호가 일치하지 않습니다.");
        return;
      }

      var response = this.$createConfirmResponse();
      this.$confirm(
        "알림",
        "회원정보 수정 시 기존의 정보는 삭제되고 새로 입력하신 정보로 변경됩니다. 그래도 입력하신 부분의 정보수정을 진행하시겠습니까?",
        "확인",
        "취소",
        response,
        {
          closed: async () => {
            if (response.result) {
              if (this.file) {
                let url = await this.uploadAvatar(this.file);
                if (url) corpInfo.avatar = url;
              }

              this.updateCorp(corpInfo)
                .then(() => {
                  this.$alert("알림", "회원정보가 수정되었습니다.", "확인", {
                    closed: () => {
                      this.getUserInfo();
                      this.activeTab = 0;
                      window.scrollTo(0, 0);
                    },
                  });
                })
                .catch((error) => {
                  this.$alert(
                    "알림",
                    "회원정보 수정 중 에러가 발생했습니다. 관리자에게 문의해주세요. <br>" +
                      error.response.data,
                  );
                });
            }
          },
        },
      );
    },
    changePhoneNumber(isValidPhoneNumber) {
      if (
        isValidPhoneNumber &&
        this.originalPhoneNumber != this.signupInfo.phone
      ) {
        this.vertifyPhoneNumber = true;
      } else {
        this.vertifyPhoneNumber = false;
      }
    },
    membershipWithDrawal() {
      let idx = this.getUser.idx;
      var response = this.$createConfirmResponse();

      this.$confirm(
        "알림",
        "회원탈퇴를 하시면 회원님의 등록된 모든 정보가 삭제되어 영구적으로 복구가 불가능합니다. <br>그래도 탈퇴하시겠습니까?",
        "동의",
        "취소",
        response,
        {
          closed: () => {
            if (response.result) {
              let paramDatas = { IDX: idx };
              axios
                .post("/api/profile/delete", paramDatas)
                .then((result) => {
                  if (result.status == 200) {
                    var refreshToken = localStorage.getItem(
                      jwtUtil.LOCAL_STORAGE_KEY_REFRESH_TOKEN,
                    );
                    var userIdx = this.getUser.idx;

                    this.signout({
                      userIdx: userIdx,
                      refreshToken: refreshToken,
                    }).then(() => {
                      this.$alert("알림", "탈퇴가 완료되었습니다.", "확인", {
                        closed: () => {
                          this.$router.push({ path: "/" });
                        },
                      });
                    });
                  }
                })
                .catch((error) => {
                  this.$alert(
                    "알림",
                    "회원정보 삭제에 실패하였습니다." + error.response.data,
                  );
                });
            }
          },
        },
      );
    },
  },
};
</script>

<style scoped lang="scss">
.infoInner > .infoTitle {
  padding: 0 100px;
}

.infoInner > div > h1 {
  color: #9e1915;
}

input:disabled {
  color: #7d7d7d;
}

.profileImgBox {
  // padding: 40px 0;
  text-align: center;
}

.profileImgInputBox {
  position: relative;
  height: 400px !important;
  background-color: #efefef !important;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    object-fit: contain;
  }
}

.profileImgInputBox input[type="file"] {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.profileImgInputBox label:active {
  transform: scale(0.97);
}

.profileImgInputBox label {
  position: absolute;
  z-index: 1;
  width: 190px;
  height: 190px;
  color: #fff;
  font-size: inherit;
  line-height: normal;
  vertical-align: middle;
  background-color: transparent;
  cursor: pointer;
  left: 50%;
  margin-left: -95px;
}

.profileImgInputBox .upload-name {
  border: 0;
  display: inline-block;
  width: 100%;
  height: 100%;
  padding: 6px 20px 5px;
  /* label의 패딩값과 일치 */
  font-size: inherit;
  font-family: inherit;
  line-height: normal;
  vertical-align: middle;
  background-size: 80%;
  background-position: center;
  background-repeat: no-repeat;
  -webkit-appearance: none;
  /* 네이티브 외형 감추기 */
  -moz-appearance: none;
  appearance: none;
}

/* preview img */
.filebox .upload-display {
  /* 이미지가 표시될 지역 */
  margin-bottom: 5px;
}

@media (min-width: 768px) {
  .filebox .upload-display {
    display: inline-block;
    margin-right: 5px;
    margin-bottom: 0;
  }
}

.filebox .upload-thumb-wrap {
  /* 추가될 이미지를 감싸는 요소 */
  display: inline-block;
  width: 54px;
  padding: 2px;
  vertical-align: middle;
  border: 1px solid #ddd;
  border-radius: 5px;
  background-color: #fff;
}

.filebox .upload-display img {
  /* 추가될 이미지 */
  display: block;
  max-width: 100%;
  width: 100% \9;
  height: auto;
}

@media (max-width: 560px) {
  .infoInner > .infoTitle {
    padding: 0;
  }
}
</style>

<style scoped lang="scss">
.bspRadio ::v-deep {
  @import "~bootstrap/dist/css/bootstrap.min";
}

.bspSelectBox ::v-deep {
  @import "~bootstrap/dist/css/bootstrap.min";
  @import "~bootstrap-vue/dist/bootstrap-vue.min";
}
</style>
